export default "__VITE_ASSET__BUY8iQIE__"